module.exports = __webpack_public_path__ + "static/rg-04-6953c03cdf06b1968f1ee5e484877b9c.jpg";